import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { Button } from "~/components/ui/button";

export function AgentMemberRetireDialog(props: {
  readonly displayName: string;
  readonly open: boolean;
  readonly pending: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => Promise<void>;
}) {
  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(open) => {
        if (!props.pending) props.onOpenChange(open);
      }}
    >
      <AlertDialogPopup className="max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle>Retire {props.displayName}?</AlertDialogTitle>
          <AlertDialogDescription>
            The stable identity and history remain visible, but it cannot receive new assignments.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose render={<Button variant="outline" />} disabled={props.pending}>
            Cancel
          </AlertDialogClose>
          <Button
            variant="destructive"
            disabled={props.pending}
            onClick={() => void props.onConfirm()}
          >
            {props.pending ? "Retiring…" : "Retire agent"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
